// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"80":"TaxHisotry","216":"indexPage"}[chunkId] + "." + {"80":"081cf1cd","216":"537b037f"}[chunkId] + ".js";
};